module.exports = __webpack_public_path__ + "img/view.9f34c3b6.svg";